import { call, put, takeEvery } from "redux-saga/effects";

import {
    getAzureAlertsSuccess,
    getAzureAlertsFail,
    getAzureResourceByResourceIDSuccess,
    getAzureResourceByResourceIDFail,
    getDefaultAzureThresholdByMonitoredResourceIDSuccess,
    getDefaultAzureThresholdByMonitoredResourceIDFail,
    postDisableAzureAlertsFail,
    postDisableAzureAlertsSuccess,
    postEnableAzureAlertsFail,
    postEnableAzureAlertsSuccess,
    postSpecificAzureCreateResourceAlertsFail,
    postSpecificAzureCreateResourceAlertsSuccess,
    postSpecificAzureResourceServiceMappingSuccess,
    postSpecificAzureResourceServiceMappingFail,
    putAzureAlertsSuccess,
    putAzureAlertsFail,
    getMissingAzureAlertsByResourceIDFail,
    getMissingAzureAlertsByResourceIDSuccess,
    getAzureDynamicAlertsSuccess,
    getAzureDynamicAlertsFail,
    getMissingAzureDynamicAlertsByResourceIDFail,
    getMissingAzureDynamicAlertsByResourceIDSuccess,
    postSpecificAzureCreateResourceAlertsDynamicSuccess,
    postSpecificAzureCreateResourceAlertsDynamicFail
} from "./actions"
import {
    GET_AZURE_ALERT, GET_AZURE_RESOURCE_BY_RESOURCE_ID, GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID,POST_DISABLE_AZURE_ALERTS,POST_ENABLE_AZURE_ALERTS,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS,POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING, PUT_AZURE_ALERTS, GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_AZURE_DYNAMIC_ALERT, GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID, POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC
} from "./actionTypes"

import {
    getAzureAlertsUrl,
    getAzureResourceByIDUrl,
    getDefaultAzureThresholdByMonitoredResourceIDUrl,
    postEnableAzureAlertUrl,
    postDisableAzureAlertUrl,
    putUpdateAzureAlertUrl,
    postAzureServiceMapping,
    postCreateAzureResourceAlertsUrl,
    getAzureMissingAlertsByResourceIDUrl,
    getAzureDynamicAlertsUrl,
    getAzureMissingDynamicAlertsByResourceIdUrl,
    postCreateAzureResourceAlertsDynamicUrl
} from "../../helpers/fakebackend_helper"

import { showNotification } from "components/Common/notification";

function* onGetAzureAlerts(monitored_resource_id) {
    try {
        const response = yield call(getAzureAlertsUrl, monitored_resource_id.payload);
        let final_response = {}
        final_response[monitored_resource_id.payload] = response;
        yield put(getAzureAlertsSuccess(final_response));
    } catch (error) {
        yield put(getAzureAlertsFail(error));
    }
}

function* onGetAzureResourceByID(resource_id) {
    try {
        const response = yield call(getAzureResourceByIDUrl, resource_id.payload);
        yield put(getAzureResourceByResourceIDSuccess(response));
    } catch (error) {
        yield put(getAzureResourceByResourceIDFail(error.message));
    }
}


function* onGetDefaultAzureThresholdMissingAlertsByResourceID(resource_id) {
    try {
        const response = yield call(getDefaultAzureThresholdByMonitoredResourceIDUrl, resource_id.payload);
        yield put(getDefaultAzureThresholdByMonitoredResourceIDSuccess(response));
    } catch (error) {
        yield put(getDefaultAzureThresholdByMonitoredResourceIDFail(error.message));
    }
}


function* onPostDisableAzureAlerts({ payload: { data } }) {
    try {
        const response = yield call(postDisableAzureAlertUrl, data);
        yield put(postDisableAzureAlertsSuccess(response));
        if (response) {
            showNotification("success", "Disabled the Azure Alerts successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postDisableAzureAlertsFail(error));
        if (error) {
            showNotification("error", "Failed to disable the Azure Alerts");
        }
    }
}

function* onPostEnableAzureAlerts({ payload: { data } }) {
    try {
        const response = yield call(postEnableAzureAlertUrl, data)
        yield put(postEnableAzureAlertsSuccess(response));
        if (response) {
            showNotification("success", "Enabled the Azure Alerts successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postEnableAzureAlertsFail(error));
        if (error) {
            showNotification("error", "Failed to enable the Azure Alerts");
        }
    }
}

function* onPutUpdateAzureAlerts({ payload: { data } }) {
    try {
        const response = yield call(putUpdateAzureAlertUrl, data);
        yield put(putAzureAlertsSuccess(response));
        window.location.reload();
    } catch (error) {
        yield put(putAzureAlertsFail(error.message));
        if (error) {
            showNotification("error", "Failed to update Azure Alert");
        }
    }
}

function* onPostResourceServiceMapping({ payload: { data } }) {
    try {
        const response = yield call(postAzureServiceMapping, data);
        yield put(postSpecificAzureResourceServiceMappingSuccess(response));
        if (response) {
            showNotification("success", "Service Mapping updated successfully!");
        }
        window.location.reload()
    } catch (error) {
        yield put(postSpecificAzureResourceServiceMappingFail(error.message));
        if (error) {
            showNotification("error", "Failed to update");
        }
    }
}

function* onGetAzureMissingAlertsByResourceID(resource_id) {
    try {
        const response = yield call(getAzureMissingAlertsByResourceIDUrl, resource_id.payload);
        yield put(getMissingAzureAlertsByResourceIDSuccess(response));
    } catch (error) {
        yield put(getMissingAzureAlertsByResourceIDFail(error.message));
    }
}


function* onPostSpecificAzureCreateResourceAlerts({ payload: { data } }) {
    try {
        const response = yield call(postCreateAzureResourceAlertsUrl, data);
        yield put(postSpecificAzureCreateResourceAlertsSuccess(response));
    } catch (error) {
        yield put(postSpecificAzureCreateResourceAlertsFail(error));
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onPostSpecificAzureCreateResourceAlertsDynamic({ payload: { data } }) {
    try {
        const response = yield call(postCreateAzureResourceAlertsDynamicUrl, data);
        yield put(postSpecificAzureCreateResourceAlertsDynamicSuccess(response));
    } catch (error) {
        yield put(postSpecificAzureCreateResourceAlertsDynamicFail(error));
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}
function* onGetAzureDynamicAlerts(monitored_resource_id) {
    try {
        const response = yield call(getAzureDynamicAlertsUrl, monitored_resource_id.payload);
        yield put(getAzureDynamicAlertsSuccess(response));
    } catch (error) {
        yield put(getAzureDynamicAlertsFail(error));
    }
}

function* onGetAzureMissingDynamicAlertsByResourceID(resource_id) {
    try {
        const response = yield call(getAzureMissingDynamicAlertsByResourceIdUrl, resource_id.payload);
        yield put(getMissingAzureDynamicAlertsByResourceIDSuccess(response));
    } catch (error) {
        yield put(getMissingAzureDynamicAlertsByResourceIDFail(error.message));
    }
}



function* AzureAlertSaga() {
    yield takeEvery(GET_AZURE_ALERT, onGetAzureAlerts);
    yield takeEvery(GET_AZURE_RESOURCE_BY_RESOURCE_ID, onGetAzureResourceByID);
    yield takeEvery(GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID, onGetDefaultAzureThresholdMissingAlertsByResourceID)
    yield takeEvery(POST_ENABLE_AZURE_ALERTS,onPostEnableAzureAlerts);
    yield takeEvery(POST_DISABLE_AZURE_ALERTS,onPostDisableAzureAlerts)
    yield takeEvery(POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS,onPostSpecificAzureCreateResourceAlerts)
    yield takeEvery(POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING,onPostResourceServiceMapping)
    yield takeEvery(PUT_AZURE_ALERTS,onPutUpdateAzureAlerts)
    yield takeEvery(GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID,onGetAzureMissingAlertsByResourceID)
    yield takeEvery(GET_AZURE_DYNAMIC_ALERT, onGetAzureDynamicAlerts)
    yield takeEvery(GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID, onGetAzureMissingDynamicAlertsByResourceID)
    yield takeEvery(POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC, onPostSpecificAzureCreateResourceAlertsDynamic)
}

export default AzureAlertSaga;